import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsBanner() {
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-12 md:pb-16 px-6 overflow-hidden" data-id="element-244">
      <motion.div className="max-w-5xl mx-auto text-center relative" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} data-id="element-245">
        {/* Green glow behind the text */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[20%] w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-246" />

        <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight relative z-10" data-id="element-247">
          Más Testimonios de
          <br data-id="element-248" />
          los resultados de
          <br data-id="element-249" />
          <span className="text-brand-green" data-id="element-250">EMPRENDE DIGITAL</span>
        </h2>
        <p className="text-lg md:text-2xl text-gray-600 mt-4 relative z-10" data-id="element-251">
          Lo que pasa cuando aplican esta guía 👇
        </p>
      </motion.div>
    </section>;
}